import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { LanguageProvider } from "./context/LanguageContext";
import { AuthProvider } from "./context/AuthContext";

import PublicLayout from "./components/PublicLayout";
import ProtectedRoute from "./components/ProtectedRoute";

import Home from "./pages/Home";
import AcademyList from "./pages/AcademyList";
import FachbereichDetail from "./pages/FachbereichDetail";
import Workshops from "./pages/Workshops";
import Events from "./pages/Events";
import Lehrpersonen from "./pages/Lehrpersonen";
import Galerie from "./pages/Galerie";
import Kontakt from "./pages/Kontakt";
import Anmeldung from "./pages/Anmeldung";
import About from "./pages/About";

import AdminLogin from "./pages/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import Dashboard from "./pages/admin/Dashboard";
import Students from "./pages/admin/Students";
import Teachers from "./pages/admin/Teachers";
import Departments from "./pages/admin/Departments";
import Courses from "./pages/admin/Courses";
import AdminWorkshops from "./pages/admin/Workshops";
import AdminEvents from "./pages/admin/Events";
import Enrollments from "./pages/admin/Enrollments";
import Attendance from "./pages/admin/Attendance";
import Payments from "./pages/admin/Payments";
import MonthlyBilling from "./pages/admin/MonthlyBilling";
import Settlements from "./pages/admin/Settlements";
import Gallery from "./pages/admin/Gallery";
import { useLang } from "./context/LanguageContext";

const MUSIC_HEADER = "https://static.prod-images.emergentagent.com/jobs/82d322bb-8683-4464-9e82-a2f337ae15fc/images/c1493b10a9e751f9ecb68534657f0a57383f5b7de269182028ab6e24b7ed8022.png";
const DANCE_HEADER = "https://images.unsplash.com/photo-1746983047239-cb817eba7d05?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwyfHxpbmRpYW4lMjBjbGFzc2ljYWwlMjBkYW5jZSUyMHBlcmZvcm1hbmNlJTIwZGFya3xlbnwwfHx8fDE3ODAxNTI1MzZ8MA&ixlib=rb-4.1.0&q=85";

const MusicAcademyPage = () => {
  const { t } = useLang();
  return <AcademyList category="music" title={t("home.musicTitle")} tamilSubtitle={t("home.musicTitleTamil")} intro={t("home.musicSub")} headerImg={MUSIC_HEADER} />;
};
const DanceAcademyPage = () => {
  const { t } = useLang();
  return <AcademyList category="dance" title={t("home.danceTitle")} tamilSubtitle={t("home.danceTitleTamil")} intro={t("home.danceSub")} headerImg={DANCE_HEADER} />;
};

const Wrap = ({ children }) => <PublicLayout>{children}</PublicLayout>;

function App() {
  return (
    <div className="App dark">
      <HelmetProvider>
        <LanguageProvider>
          <AuthProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Wrap><Home /></Wrap>} />
                <Route path="/musikakademie" element={<Wrap><MusicAcademyPage /></Wrap>} />
                <Route path="/tanzakademie" element={<Wrap><DanceAcademyPage /></Wrap>} />
                <Route path="/fachbereich/:slug" element={<Wrap><FachbereichDetail /></Wrap>} />
                <Route path="/workshops" element={<Wrap><Workshops /></Wrap>} />
                <Route path="/events" element={<Wrap><Events /></Wrap>} />
                <Route path="/lehrpersonen" element={<Wrap><Lehrpersonen /></Wrap>} />
                <Route path="/galerie" element={<Wrap><Galerie /></Wrap>} />
                <Route path="/kontakt" element={<Wrap><Kontakt /></Wrap>} />
                <Route path="/anmeldung" element={<Wrap><Anmeldung /></Wrap>} />
                <Route path="/ueber-uns" element={<Wrap><About /></Wrap>} />
                <Route path="/datenschutz" element={<Wrap><About /></Wrap>} />
                <Route path="/impressum" element={<Wrap><About /></Wrap>} />

                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
                  <Route index element={<Dashboard />} />
                  <Route path="students" element={<Students />} />
                  <Route path="teachers" element={<Teachers />} />
                  <Route path="departments" element={<Departments />} />
                  <Route path="courses" element={<Courses />} />
                  <Route path="workshops" element={<AdminWorkshops />} />
                  <Route path="events" element={<AdminEvents />} />
                  <Route path="enrollments" element={<Enrollments />} />
                  <Route path="attendance" element={<Attendance />} />
                  <Route path="payments" element={<Payments />} />
                  <Route path="monthly-billing" element={<MonthlyBilling />} />
                  <Route path="settlements" element={<Settlements />} />
                  <Route path="gallery" element={<Gallery />} />
                </Route>
              </Routes>
            </BrowserRouter>
          </AuthProvider>
        </LanguageProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
